goog.provide('el8.apphome.reqAct.urgents');

goog.require('el8.apphome.reqAct.QueueTab');


el8.apphome.reqAct.urgents = (function() {

    var name = 'urgents';

    var that = new el8.apphome.reqAct.QueueTab({
        name: name,
        title: 'Urgent',
        emptyMsg: 'No urgent items requiring action'
    });

    return that;

})();

